<!-- TODO @aurore utiliser un seul composant pour opportunité et intention (dans components/I3pComponent/common/list/Pagination.vue ? ) -->
<script lang="ts">
export default {
    name: 'Pagination',
    props: {
        list: { type: Object, required: true },
    },
    emits: ['loadData'],
    computed: {
        meta() {
            return this.list?.meta || {}
        },
        number: {
            get() {
                return this.$parent.i3pService.getPagination()?.number
            },
            set(newValue: number) {
                this.$parent?.i3pService?.setPagination({ number: newValue, size: this.size })
                this.$emit('loadData')
            },
        },
        size: {
            get() {
                return this.$parent.i3pService.getPagination()?.size
            },
            set(newValue: number) {
                this.$parent?.i3pService?.setPagination({ number: this.number, size: newValue })
                this.$emit('loadData')
            },
        },
    },
    methods: {
    },

}
</script>

<template>
    <v-row
        no-gutterse
        class="pagination pt-5 px-2"
    >
        <v-col
            cols="12"
            lg="2"
            sm="4"
            class="pa-2"
        >
            <!-- v-model="size" -->
            Éléments par page
            <v-select
                :value="meta.per_page"
                class="number-per-page"
                :items="[10, 20, 30, 50, 100]"
                variant="solo"
                @update:model-value="size = $event"
            />
        </v-col>
        <v-col
            cols="12"
            sm="8"
            class="pa-2"
        >
            <v-skeleton-loader
                v-if="!list"
                type="subtitle"
            />
            <v-pagination
                v-else
                v-model="number"
                :length="meta.last_page"
                :value="meta.current_page"
                :total-visible="$vuetify.display.mobile ? '2' : '6'"
                active-color="primary"
            />
        </v-col>
        <v-col
            cols="12"
            lg="2"
            class="pa-2"
        >
            <div
                v-if="meta.total"
                class="pt-4 text-center"
            >
                {{ meta.total }} éléments
            </div>
        </v-col>
    </v-row>
</template>
